import React from 'react';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function MemberDetail(props) {
    const { data } = props;//props

    /* =============== 카테고리필터 =============== */
    const categoryFiler = (type) => {
        switch(type) {
            case 1 : return '[엔진오일]';
            case 2 : return '[타이어]';
            case 3 : return '[정기점검]';
            case 4 : return '[기타]';
        }
    }
    /* =============== 카테고리필터 =============== */

    return (
        <Element tag={`article`}>
            {data[0]?.RESULT_LIST.map((item, idx) =>
                <div key={idx}>
                    <div>
                        {item.BRAND_KOR_NAME !== undefined ?
                            <>
                            <label>차량</label>
                            <div>
                                <span>{item.BRAND_KOR_NAME}</span>
                                <span>{item.MODEL_KOR_NAME}</span>
                            </div>
                            </>
                        : null}
                    </div>
                    <div>
                        <label>카테고리</label>
                            {item?.ITEM_LIST.map((item, idx) =>
                                <div key={idx}>
                                    <span>{categoryFiler(item.CATEGORY)}</span>
                                    <small>{item.ITEM_NAME}</small>
                                </div>
                            )}
                    </div>
                    <div>
                        <label>정비내용</label>
                        <pre>{item.RESULT}</pre>
                        {item.REMARK !== undefined ? 
                            <><label>특이사항</label><pre>{item.REMARK}</pre></>
                        :   null}
                    </div>
                </div>
            )}
        </Element> 
    );
}